export default {"src":"/evde-internet/_next/static/media/desktop-promo.5ab809b6.svg","height":230,"width":610};